import { EntityReducers } from '../EntityReducer';
import { RootState } from '../rootReducer';
import { createAppUseGetByIds, createUseGetById } from '@hwm/ui-lib/core/store';

export const useGetById = createUseGetById<RootState, EntityReducers>();
export const useGetByIds = createAppUseGetByIds<RootState, EntityReducers>();

export type UseEntityThunkResponse<Response, Payload> = [
  Payload extends void ? () => Promise<Response> : (payload: Payload) => Promise<Response>,
  boolean,
  string,
];
